module.exports = __webpack_public_path__ + "static/media/footer 2.f88a4022.png";